// ScienceToken Platform Data
// All data is mock/virtual for demonstration purposes

export const SCIENCE_LLMS = [
  {
    id: "xtalpi-science-flagship",
    name: "XtalPi Science Flagship",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Flagship",
    contextLength: 131072,
    inputPrice: 18,
    outputPrice: 54,
    tags: ["SMILES", "FASTA", "InChI", "PDF", "Multi-modal"],
    description: "晶泰科技自研旗舰科学大语言模型，原生理解 SMILES、FASTA、InChI 等科学格式，支持多模态输入，专为药物发现和材料科学场景优化。",
    descriptionEn: "XtalPi's proprietary flagship scientific LLM that natively understands SMILES, FASTA, InChI, and other scientific formats. Supports multimodal input, optimized for drug discovery and materials science.",
    capabilities: ["Molecular Property Prediction", "Reaction Prediction", "Literature Analysis", "Hypothesis Generation", "ADMET Reasoning"],
    status: "available",
    isNew: false,
    isFeatured: true,
  },
  {
    id: "xtalpi-science-standard",
    name: "XtalPi Science Standard",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Standard",
    contextLength: 65536,
    inputPrice: 4,
    outputPrice: 12,
    tags: ["SMILES", "FASTA", "Open Source"],
    description: "晶泰科技标准版科学大语言模型，在旗舰模型基础上优化推理成本，适用于大批量分子性质预测和科学问答任务，性价比极高。",
    descriptionEn: "XtalPi's standard scientific LLM, optimized for inference cost based on the flagship model. Suitable for large-batch molecular property prediction and scientific QA tasks with exceptional cost-effectiveness.",
    capabilities: ["Molecular Property Prediction", "Scientific QA", "Reaction Analysis"],
    status: "available",
    isNew: false,
    isFeatured: false,
  },
  {
    id: "xtalpi/xtalfold",
    name: "XtalFold™",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 131072,
    inputPrice: 24,
    outputPrice: 72,
    tags: ["FASTA", "PDB", "Protein", "Structure"],
    description: "晶泰科技自研蛋白质结构预测旗舰模型，1天内完成从序列到结构的全流程预测，精度达到原子级别；已授权全球多家顶级药企使用，在蛋白质-配体复合物预测上表现领先。",
    descriptionEn: "XtalPi's proprietary flagship protein structure prediction model. Completes full-pipeline prediction from sequence to structure within 1 day at atomic-level accuracy. Licensed by multiple top global pharma companies, with leading performance on protein-ligand complex prediction.",
    capabilities: ["Protein Structure Prediction", "Protein-Ligand Complex", "Binding Site Analysis", "Structural Validation"],
    status: "available",
    isNew: false,
    isFeatured: true,
  },
  {
    id: "xtalpi/xfep",
    name: "XFEP",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 65536,
    inputPrice: 30,
    outputPrice: 90,
    tags: ["SMILES", "FEP", "Binding Affinity", "Drug Design"],
    description: "基于量子物理的自由能微扰（FEP）高精度结合亲和力预测，准确度与湿实验方法相当；已在辉瑞等顶级药企的药物发现项目中验证，显著加速先导化合物优化周期。",
    descriptionEn: "Quantum physics-based Free Energy Perturbation (FEP) for high-accuracy binding affinity prediction, comparable to wet lab methods. Validated in drug discovery projects at top pharma companies including Pfizer, significantly accelerating lead optimization cycles.",
    capabilities: ["Binding Affinity Prediction", "Lead Optimization", "RBFE Calculation", "ABFE Calculation"],
    status: "available",
    isNew: false,
    isFeatured: false,
  },
  {
    id: "xtalpi/xmolgen",
    name: "XMolGen",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 65536,
    inputPrice: 20,
    outputPrice: 60,
    tags: ["SMILES", "Generative", "Drug Design", "Chemical Space"],
    description: "AI 驱动的分子生成工具，可探索超大化学空间，支持基于靶点结构、药效团约束和 ADMET 多目标优化的分子设计策略；已生成超过 1000 万个新型分子骨架。",
    descriptionEn: "AI-driven molecular generation tool capable of exploring ultra-large chemical space. Supports target structure-based, pharmacophore-constrained, and ADMET multi-objective optimization strategies. Has generated over 10 million novel molecular scaffolds.",
    capabilities: ["De Novo Molecular Design", "Scaffold Hopping", "Multi-objective Optimization", "Chemical Space Exploration"],
    status: "available",
    isNew: true,
    isFeatured: false,
  },
  {
    id: "xtalpi/xtalgazer-csp",
    name: "XtalGazer™ CSP",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 65536,
    inputPrice: 28,
    outputPrice: 84,
    tags: ["Crystal", "Polymorph", "Solid Form", "CSD"],
    description: "药物固体形态（晶型/盐型/共晶）AI 预测平台；2016年辉瑞全球晶型预测盲测中实现100%准确预测，已服务全球前20大药企中的17家，是固体制剂研发的核心工具。",
    descriptionEn: "AI prediction platform for pharmaceutical solid forms (polymorphs/salts/co-crystals). Achieved 100% accuracy in Pfizer's 2016 global polymorph prediction blind test. Serves 17 of the world's top 20 pharmaceutical companies and is a core tool for solid dosage form development.",
    capabilities: ["Crystal Structure Prediction", "Polymorph Screening", "Salt/Co-crystal Design", "Stability Assessment"],
    status: "available",
    isNew: false,
    isFeatured: false,
  },
  {
    id: "xtalpi/reaction-predictor",
    name: "Reaction Predictor",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 65536,
    inputPrice: 16,
    outputPrice: 48,
    tags: ["SMILES", "Reaction", "Synthesis", "Organic Chemistry"],
    description: "支持 20+ 反应类型的高精度反应预测模型，每月处理 3 万+ 反应产率数据，累计超 200 万条反应数据训练；支持正向反应预测、逆合成规划和反应条件优化。",
    descriptionEn: "High-accuracy reaction prediction model supporting 20+ reaction types. Processes 30,000+ reaction yield data points monthly, trained on 2M+ cumulative reaction data. Supports forward reaction prediction, retrosynthesis planning, and reaction condition optimization.",
    capabilities: ["Forward Reaction Prediction", "Retrosynthesis Planning", "Yield Prediction", "Condition Optimization"],
    status: "available",
    isNew: false,
    isFeatured: false,
  },
  {
    id: "xtalpi/admet-predictor",
    name: "ADMET Predictor",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 65536,
    inputPrice: 12,
    outputPrice: 36,
    tags: ["SMILES", "ADMET", "Drug-likeness", "Toxicity"],
    description: "对化合物的成药性（吸收、分布、代谢、排泄、毒性）进行全面预测，覆盖 50+ ADMET 终点，准确率达到湿实验水平；已集成在多家顶级药企的早期筛选流程中。",
    descriptionEn: "Comprehensive prediction of compound drug-likeness (Absorption, Distribution, Metabolism, Excretion, Toxicity) covering 50+ ADMET endpoints with wet lab-level accuracy. Integrated into early screening pipelines at multiple top pharmaceutical companies.",
    capabilities: ["ADMET Prediction", "Toxicity Assessment", "Drug-likeness Scoring", "PK Property Prediction"],
    status: "available",
    isNew: false,
    isFeatured: false,
  },
  {
    id: "xtalpi/materials-predictor",
    name: "Materials Predictor",
    provider: "XtalPi",
    providerShort: "XP",
    tier: "Proprietary",
    contextLength: 65536,
    inputPrice: 22,
    outputPrice: 66,
    tags: ["CIF", "Materials", "Energy", "New Energy"],
    description: "预测晶体结构、电子性质、力学性质等多维材料属性，已应用于钙钛矿、光伏材料、固态电解质等新能源领域；与全球最大光伏企业建立战略合作，加速新材料研发周期。",
    descriptionEn: "Predicts crystal structure, electronic properties, mechanical properties, and other multi-dimensional material attributes. Applied in perovskite, photovoltaic materials, solid electrolytes, and other new energy fields. Strategic partnership with the world's largest solar panel manufacturer to accelerate new material development.",
    capabilities: ["Crystal Structure Prediction", "Electronic Property Prediction", "Mechanical Property Prediction", "New Energy Materials"],
    status: "available",
    isNew: true,
    isFeatured: false,
  },
];

export const COMPUTE_MODELS: any[] = [];

export const DATABASES: any[] = [];


// Mock dashboard data
export const MOCK_USAGE_DATA = Array.from({ length: 30 }, (_, i) => {
  const date = new Date();
  date.setDate(date.getDate() - (29 - i));
  const base = 50000 + Math.random() * 100000;
  return {
    date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    llm: Math.floor(base * 0.8 + Math.random() * 30000),
  };
});

export const MOCK_RECENT_CALLS = [
  { id: "call_001", time: "2 min ago", model: "xtalpi-science-flagship", status: "success", tokens: 2847, latency: 1240 },
  { id: "call_003", time: "15 min ago", model: "xtalpi/science-standard", status: "success", tokens: 5621, latency: 890 },
  { id: "call_005", time: "1 hr ago", model: "xtalpi-science-flagship", status: "error", tokens: 0, latency: 0 },
  { id: "call_007", time: "3 hr ago", model: "xtalpi/science-standard", status: "success", tokens: 1234, latency: 650 },
];

export const MOCK_API_KEYS = [
  { id: "key_001", name: "生产环境 Key", nameEn: "Production Key", key: "sk-st-prod...x8Kp", created: "2025-12-01", lastUsed: "Just now", monthlyUsage: 284750, limit: null, status: "active" },
  { id: "key_002", name: "开发测试 Key", nameEn: "Development Test Key", key: "sk-st-dev...m3Qr", created: "2026-01-15", lastUsed: "3 days ago", monthlyUsage: 45200, limit: 100000, status: "active" },
  { id: "key_003", name: "开发测试 Key", nameEn: "Development Key", key: "sk-st-nex...p7Wz", created: "2026-02-20", lastUsed: "1 hr ago", monthlyUsage: 128900, limit: null, status: "active" },
];

export const MOCK_TEAM_MEMBERS = [
  { id: "u1", name: "Zhang Wei", email: "zhangwei@xtalpi.com", role: "Admin", joined: "2025-11-01", monthlyUsage: 180000, avatar: "ZW" },
  { id: "u2", name: "Li Fang", email: "lifang@xtalpi.com", role: "Developer", joined: "2025-12-15", monthlyUsage: 95000, avatar: "LF" },
  { id: "u3", name: "Chen Jing", email: "chenjing@xtalpi.com", role: "Developer", joined: "2026-01-08", monthlyUsage: 67000, avatar: "CJ" },
  { id: "u4", name: "Wang Hao", email: "wanghao@xtalpi.com", role: "Viewer", joined: "2026-02-20", monthlyUsage: 12000, avatar: "WH" },
];

export const MOCK_BILLING_HISTORY = [
  { month: "May 2026", consumption: 458920, amount: 45.89, status: "current" },
  { month: "Apr 2026", consumption: 612480, amount: 61.25, status: "paid" },
  { month: "Mar 2026", consumption: 389200, amount: 38.92, status: "paid" },
  { month: "Feb 2026", consumption: 521700, amount: 52.17, status: "paid" },
  { month: "Jan 2026", consumption: 298400, amount: 29.84, status: "paid" },
];


export const MOCK_EXPERIMENT_LOGS = [
  { id: "log_001", requestId: "req_a1b2c3d4", model: "xtalpi-science-flagship", type: "llm", status: "success", timestamp: "2026-05-21 14:23:01", tokens: 2847, inputTokens: 512, outputTokens: 2335, latency: 1240, cost: 0.18, keyName: "生产环境 Key" },
  { id: "log_003", requestId: "req_c3d4e5f6", model: "xtalpi/science-standard", type: "llm", status: "success", timestamp: "2026-05-21 14:08:44", tokens: 5621, inputTokens: 1200, outputTokens: 4421, latency: 890, cost: 0.07, keyName: "生产环境 Key" },
  { id: "log_005", requestId: "req_e5f6g7h8", model: "xtalpi-science-flagship", type: "llm", status: "failed", timestamp: "2026-05-21 13:41:33", tokens: 0, latency: 0, cost: 0, keyName: "开发测试 Key", errorMessage: "Rate limit exceeded: 429 Too Many Requests" },
  { id: "log_009", requestId: "req_i9j0k1l2", model: "xtalpi/science-standard", type: "llm", status: "success", timestamp: "2026-05-21 11:45:30", tokens: 1234, inputTokens: 400, outputTokens: 834, latency: 650, cost: 0.01, keyName: "开发测试 Key" },
];

export const MOCK_BILLING_DATA = {
  balance: 34250,
  monthlySpent: 28475,
  serviceBreakdown: [
    { service: "Science LLMs", amount: 28475, pct: 100, color: "#3B82F6" },
  ],
  monthlyTrend: [
    { month: "Dec", llm: 8400 },
    { month: "Jan", llm: 9800 },
    { month: "Feb", llm: 11200 },
    { month: "Mar", llm: 10400 },
    { month: "Apr", llm: 13600 },
    { month: "May", llm: 12840 },
  ],
  transactions: [
    { id: "tx_001", type: "usage", service: "Science LLMs", description: "LLM API Usage - May 2026", date: "2026-05-21", amount: 12840 },
    { id: "tx_003", type: "topup", service: null, description: "Credit Top-up via Alipay", date: "2026-05-15", amount: 50000 },
    { id: "tx_005", type: "topup", service: null, description: "Credit Top-up via WeChat Pay", date: "2026-04-01", amount: 100000 },
  ],
};

// Fix team members with correct fields
export const MOCK_TEAM_MEMBERS_V2 = [
  { id: "u1", name: "Zhang Wei", email: "zhangwei@xtalpi.com", role: "Owner", department: "Computational Chemistry", joined: "2025-11-01", monthlyUsage: 180000, lastActive: "Today" },
  { id: "u2", name: "Li Fang", email: "lifang@xtalpi.com", role: "Admin", department: "Drug Discovery", joined: "2025-12-15", monthlyUsage: 95000, lastActive: "Today" },
  { id: "u3", name: "Chen Jing", email: "chenjing@xtalpi.com", role: "Member", department: "Materials Science", joined: "2026-01-08", monthlyUsage: 67000, lastActive: "Yesterday" },
  { id: "u4", name: "Wang Hao", email: "wanghao@xtalpi.com", role: "Member", department: "Bioinformatics", joined: "2026-02-20", monthlyUsage: 42000, lastActive: "3 days ago" },
  { id: "u5", name: "Zhao Min", email: "zhaomin@xtalpi.com", role: "Viewer", department: "Research", joined: "2026-03-10", monthlyUsage: 12000, lastActive: "Today" },
];
